export const menuItemCustomers = [
    {
        id: 1,
        label: 'module.company',
        icon: 'mdi mdi-account',
        subItems: [
            {
                id: 2,
                label: 'module.company',
                link: '/company'
            },
            {
                id: 2,
                label: 'module.companyLocation',
                link: '/company-location'
            },
            {
                id: 3,
                label: 'module.staff',
                link: '/staff'
            },
            {
                id: 4,
                label: 'module.menu',
                link: '/menu'
            },
            {
                id: 5,
                label: 'module.service',
                link: '/service'
            },
            {
                id: 6,
                label: 'module.package',
                link: '/package'
            },
            {
                id: 7,
                label: 'module.closePeriod',
                link: '/close-period'
            },
            {
                id: 8,
                label: 'module.checkPoint',
                link: '/check-point'
            },
            {
                id: 9,
                label: 'module.transaction',
                link: '/transaction'
            },
            {
                id: 10,
                label: 'module.inspectionReport',
                link: '/inspection-report'
            },
            {
                id: 11,
                label: 'module.report',
                link: '/report'
            },
            {
                id: 12,
                label: 'module.order',
                link: '/order'
            },
            {
                id: 13,
                label: 'module.vehicle',
                link: '/vehicle'
            },
            {
                id: 14,
                label: 'module.customer',
                link: '/customer'
            },
        ]
    },
]